import React from 'react';
import PropTypes from 'prop-types';
import PVModalDialog from './PVModalDialog';

const PVGenericModal = ({
    isOpen,
    setIsOpen,
    acceptLabel,
    cancelLabel,
    optionalLabel,
    headerContents,
    bodyContents,
    responseFunction,
    acceptFunction,
    optionalFunction,
}) => {
    const acceptButton = (
        <button
            type="button"
            onClick={() => {
                responseFunction(true);
                setIsOpen(false);
                if (typeof acceptFunction === 'function') {
                    acceptFunction();
                }
            }}
            className="pv btn btn-primary"
        >
            {acceptLabel}
        </button>
    );

    const cancelButton = (
        <button
            type="button"
            onClick={() => {
                responseFunction(false);
                setIsOpen(false);
            }}
            className="pv btn btn-primary"
        >
            {cancelLabel}
        </button>
    );

    const optionalButton = (
        <button
            type="button"
            onClick={() => {
                responseFunction(false);
                optionalFunction(true);
                setIsOpen(false);
            }}
            className="pv btn btn-primary"
        >
            {optionalLabel}
        </button>
    );

    return (
        <PVModalDialog
            isOpen={isOpen}
            onRequestClose={() => {
                responseFunction(false);
                setIsOpen(false);
            }}
            headerContent={headerContents}
            bodyContent={bodyContents}
            footerContent={
                <React.Fragment>
                    <span className="pull-left">{acceptButton}</span>
                    {optionalLabel !== '' && (
                        <span className="pull-left">&nbsp;&nbsp;{optionalButton}</span>
                    )}
                    {cancelLabel !== 'none' && <span className="pull-right">{cancelButton}</span>}
                </React.Fragment>
            }
            className="modal-dialog"
            overlayClassName="modal-overlay"
            shouldCloseOnOverlayClick={false}
        />
    );
};

PVGenericModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    setIsOpen: PropTypes.func.isRequired,
    acceptLabel: PropTypes.string,
    cancelLabel: PropTypes.string,
    headerContents: PropTypes.string.isRequired,
    bodyContents: PropTypes.string,
    responseFunction: PropTypes.func.isRequired,
    acceptFunction: PropTypes.func,
    optionalLabel: PropTypes.string,
    optionalFunction: PropTypes.func,
};

PVGenericModal.defaultProps = {
    acceptLabel: 'Accept',
    cancelLabel: 'Cancel',
    bodyContents: '',
    acceptFunction: () => {},
    optionalLabel: '',
    optionalFunction: () => {},
};

export default PVGenericModal;
